module.exports = __webpack_public_path__ + "img/300x210b.7c7dcbcb.jpg";